export let hc_utils = {
    'vars': {
        'monthArr': ['01','02','03','04','05','06','07','08','09','10','11','12']
    }
};

/*
----------------------------
Module - Utilities
----------------------------
*/
// submit actions for forms
hc_utils.loader = function(element, toggler) {

    if(toggler){
        // generate loader ele
        let newDiv = document.createElement("div");
        newDiv.classList.add('loader');
        newDiv.classList.add('animate__animated');
        newDiv.classList.add('animate__fadeIn');
        let newContent = document.createTextNode("Loading...");
        newDiv.appendChild(newContent);
        // place it where it is needed
        element.classList.add('loading');
        element.appendChild(newDiv);
    } else {
        element.removeChild(element.querySelector('.loader'));
        element.classList.remove('loading');
    }
};

// notifictions
// receives html
hc_utils.notifier = function(content) {
    hccosp.vars.notifier.innerHTML = content;
};

// set sessionStorage
hc_utils.getSessionStorage = function(name){
    return JSON.parse(sessionStorage.getItem(name));
}
// set sessionStorage
hc_utils.setSessionStorage = function(name,storage){
    if(name && storage){
        sessionStorage.setItem(name, JSON.stringify(storage));
    }
}


// checks if a date is in the past. Expects Due_Date in the format of mm/dd/yyyy 00:00:00
hc_utils.dateIsInThePast = function(dateStr){
    const inputDate = dateStr;
    const currentDate = new Date();
    // return bool
    return new Date(inputDate) < currentDate;
}


// date string cleanser
hc_utils.cleanDate = function(dateStr){
    // 2022-04-04 00:00:00
    // 1968-06-21 00:00:00
    // 2022-07-01
    let returnDate = '';
    if(dateStr && dateStr.length > 0){
        let date = new Date(dateStr);
        returnDate = `${date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`}/${hc_utils.vars.monthArr[date.getMonth()]}/${date.getFullYear()}`;
    }
    return returnDate;
}
// date string cleanser
hc_utils.cleanTime = function(timeStr){
    // 00:00:00
    // time: 15:11:41.0000000
    if(timeStr == '00:00:00'){
        return '';
    }
    let time = new Date('2022-04-04 ' + timeStr);
    let returnTime = time.toLocaleTimeString('en-NZ');
    return returnTime;
}
// date string cleanser
hc_utils.cleanPrice = function(priceStr){
    // variants seen thus far!
    // 200 | 122.5 | 240.000000 | .500000 | 

    // Create our number formatter.
    let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return formatter.format(priceStr);
}

// utility function to determine if 
// a summary screen needs the edit form rendered or not
hc_utils.hasSummaryForm = function(collection){
    let output = true;
    if(collection == 'fines'){
        output = false;
    }
    return output;
};

// utility function to determine if 
// a summary screen needs the edit form rendered or not
hc_utils.mergeFormValues = function(data){
    let output = [];
    for (const [key, value] of Object.entries(data)) {
        output.push(value.trim());
    }
    return output.join('');
};


/**
 * Returns a hash code from a string
 * @param  {String} str The string to hash.
 * @return {Number}    A 32bit integer
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
 hc_utils.hashCode = function(str) {
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        let chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
hc_utils.hashForm = function(formData) {
    // before hashing, first remove some arbitrary
    // form field that are conflicting with our change checks
    formData.delete('opt_owner');
    formData.delete('opt_email');
    formData.delete('opt_confirmation');
    formData.delete('opt_renewal');
    return hc_utils.hashCode(JSON.stringify(Object.fromEntries(formData)));
}

hc_utils.getTimestamp = function(formData) {
    return Number(Date.now().toString().slice(0,10));
}

